import { getLocale } from "../runtime";

const da_invalidpromocode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ugyldig rabatkode. Prøv igen.`
};

const en_invalidpromocode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Invalid discount code. Please try again.`
};

const es_invalidpromocode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Código de descuento inválido. Inténtalo de nuevo.`
};

const fi_invalidpromocode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Virheellinen alennuskoodi. Yritä uudelleen.`
};

const nb_invalidpromocode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ugyldig rabattkode. Prøv igjen.`
};

const sv_invalidpromocode = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ogiltig rabattkod. Försök igen.`
};

const invalidpromocode = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_invalidpromocode(inputs)
	if (locale === "en") return en_invalidpromocode(inputs)
	if (locale === "es") return es_invalidpromocode(inputs)
	if (locale === "fi") return fi_invalidpromocode(inputs)
	if (locale === "nb") return nb_invalidpromocode(inputs)
	if (locale === "sv") return sv_invalidpromocode(inputs)
	return "invalidPromoCode";
};

export { invalidpromocode as "invalidPromoCode" };